import React, { useState, useEffect } from 'react';
import UserServices from '../../services/UserServices';
import Modal from 'react-modal';

const UserStatus = ({ user, page }) => {
  // Initialize the state based on the user's status
  const [isChecked, setIsChecked] = useState(user?.status === 'Verify');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(null);

  // Sync checkbox state when user prop changes
  useEffect(() => {
    setIsChecked(user?.status === 'Verify');
  }, [user?.status]);

  // Handle checkbox toggle
  const handleToggle = async () => {
    const newStatus = isChecked ? 'UnVerify' : 'Verify';  // Correct the status toggle
    
    // If changing to Verify, show confirmation modal
    if (newStatus === 'Verify' && page === 'user') {
      setPendingStatus(newStatus);
      setShowConfirmModal(true);
      // Don't update the checkbox state yet - wait for confirmation
      return;
    }
    
    // For UnVerify, proceed directly without confirmation
    setIsChecked(!isChecked);
    if (page === 'user') {
      try {
        const res = await UserServices.updateUserStatus(user._id, {
          status: newStatus
        });

        if (res.status === 200) { // Check if the response is successful
          alert(res.data.message || 'User status updated successfully'); // Show success message from backend
        } else {
          alert('User status updated successfully'); // Show failure message
        }
      } catch (error) {
        alert('You are not eligible to update verify status of this profile since you are the one who last edited it'); // Show error message
        console.error('An error occurred while updating user status', error);
        // Revert the checkbox state on error
        setIsChecked(isChecked);
      }
    }
  };

  // Handle confirmation
  const handleConfirm = async () => {
    setShowConfirmModal(false);
    setIsChecked(true);
    
    if (page === 'user' && pendingStatus) {
      try {
        const res = await UserServices.updateUserStatus(user._id, {
          status: pendingStatus
        });

        if (res.status === 200) { // Check if the response is successful
          alert(res.data.message || 'User status updated successfully'); // Show success message from backend
        } else {
          alert('User status updated successfully'); // Show failure message
        }
      } catch (error) {
        alert('You are not eligible to update verify status of this profile since you are the one who last edited it'); // Show error message
        console.error('An error occurred while updating user status', error);
        // Revert the checkbox state on error
        setIsChecked(false);
      }
    }
    setPendingStatus(null);
  };

  // Handle cancellation
  const handleCancel = () => {
    setShowConfirmModal(false);
    setPendingStatus(null);
    // Status remains unchanged - checkbox state was never updated
  };

  return (
    <>
      <div className="check-box">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
      </div>
      
      <Modal
        isOpen={showConfirmModal}
        onRequestClose={handleCancel}
        contentLabel="Verification Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
        style={{
          content: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '400px',
            width: '90%',
            padding: '20px',
            borderRadius: '8px',
            textAlign: 'center'
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000
          }
        }}
      >
        <h3 style={{ marginBottom: '20px', fontSize: '18px', fontWeight: '600' }}>
          Verification Confirmation
        </h3>
        <p style={{ marginBottom: '30px', fontSize: '16px', lineHeight: '1.5' }}>
          Have you verified all documents before approving?
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
          <button
            onClick={handleConfirm}
            style={{
              padding: '10px 25px',
              backgroundColor: '#2eb577',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Confirm
          </button>
          <button
            onClick={handleCancel}
            style={{
              padding: '10px 25px',
              backgroundColor: '#ef4656',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </>
  );
};

export default UserStatus;



// import React, { useState } from 'react';
// import UserServices from '../../services/UserServices';

// const UserStatus = ({ user, page }) => {
//   // Initialize the state based on the user's status
//   const [isChecked, setIsChecked] = useState(user?.status === 'Verify');

//   // Handle checkbox toggle
//   const handleToggle = async () => {
//     const newStatus = isChecked ? 'UnVerify' : 'Verify';  // Correct the status toggle
//     setIsChecked(!isChecked);
//     if (page === 'user') {
//       try {
//         const res = await UserServices.updateUserStatus(user._id, {
//           status: newStatus
//         });

//         if (res.status === 200) { // Check if the response is successful
          
//         } else {
//           console.error('Failed to update user status');
//         }
//       } catch (error) {
//         console.error('An error occurred while updating user status', error);
//       }
//     }
//   };

//   return (
//     <div className="check-box">
//       <input
//         type="checkbox"
//         checked={isChecked}
//         onChange={handleToggle}
//       />
//     </div>
//   );
// };

// export default UserStatus;
